import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={17} fill="none" {...props}>
    <path fill={props.fill ? props.fill : '#FFD100'} fillRule="evenodd" d="M16 15.5H0v-3l7-12h2l7 12zm-9-11h2v5H7zm0 7h2v2H7z" clipRule="evenodd" />
  </svg>
);
export default SvgAlert;
